<template>
    <MainCard title="Dados de Integração" subtitle="Insira o seu assistente utilizando as informações abaixo.">
        <div class="tab-content d-flex justify-space-between align-start">
            <div class="tab-content-text d-flex flex-column ga-8 px-8">
                <div class="integration-data d-flex flex-column ga-6">
                    <h2 class="title-medium">Insira no seu site:</h2>
                    <div class="integration-data-content d-flex flex-column ga-4">
                        <rb-textarea 
                            rows="2" 
                            v-model="integrationDataInput" 
                            readonly 
                            width="800px" 
                            append-inner-icon="mdi-content-copy" 
                            @click:append-inner="copyLink(integrationDataInput)"
                        ></rb-textarea>
                    </div>
                </div>
                <div class="api-info d-flex flex-column ga-6">
                    <h2 class="title-medium">Informações para utilizar como API:</h2>
                    <div class="api-info-content d-flex flex-column ga-4">
                        <rb-input 
                            v-model="apiInfoInput" 
                            readonly 
                            width="800px" 
                            append-inner-icon="mdi-content-copy" 
                            @click:append-inner="copyLink(apiInfoInput)"
                        ></rb-input>
                    </div>
                </div>
                <div class="lp-config d-flex flex-column ga-6">
                    <h2 class="title-medium">Insira nos modelos de formulário:</h2>
                    <div class="api-info-content d-flex flex-column ga-4">
                        <rb-textarea 
                            v-model="lpConfigData" 
                            readonly
                            rows="2"
                            width="800px" 
                            append-inner-icon="mdi-content-copy" 
                            @click:append-inner="copyLink(lpConfigData)"
                        ></rb-textarea>
                    </div>
                </div>
                <div class="integration-data d-flex flex-column ga-6">
                    <h2 class="title-medium">Informações sobre os parâmetros:</h2>
                    <div class="integration-data-content d-flex flex-column ga-4">
                        <p class="body-medium">
                            <b>"idContato"</b>= ID do contato no Rubeus
                            <br>
                            <b>"idRegistro"</b>= ID do registro no Rubeus
                            <br>
                            <b>"codRegistro"</b>= Código do registro no Rubeus
                            <br>
                            <b>"user_code"</b>= Identificação única da conversa
                            <br>
                            <b>"msg"</b>= Mensagem do usuário para o assistente</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="navigation-buttons">
            <v-divider class="w-100"></v-divider>
            <div class="buttons-container w-100 d-flex justify-end">
                <v-btn class="px-6 py-5 d-flex" color="primary-60" rounded="xl" @click="showAssistents"> Ver assistentes </v-btn>
            </div>
        </div>
    </MainCard>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import MainCard from '@/ai_studio/components/layout/MainCard.vue';
import { useSnackbarStore } from '@/ai_studio/stores/snackbar';
const snackbar = useSnackbarStore();

const route = useRoute();
const router = useRouter()
const assistentKey = route.params.key;
const integrationDataInput = ref('');
const apiInfoInput = ref('');
const lpConfigData = ref('');

onMounted(() => {
    integrationDataInput.value = `<script defer src="${window.location.origin}/api/assistents/botClientEmbedded?key=${assistentKey}&user_code=&idContato=&idRegistro=&codRegistro="><\/script>`; //eslint-disable-line
    apiInfoInput.value = window.location.origin + "/api/assistents/startBotClient?key=" + assistentKey + "&msg=&user_code=&idContato=&idRegistro=&codRegistro=";
    lpConfigData.value = `const script = document.createElement('script');\nscript.src="${window.location.origin}/api/assistents/botClientEmbedded?key=${assistentKey}&user_code=&idContato=&idRegistro=&codRegistro=";\ndocument.head.appendChild(script);`;
});

const copyLink = (text) => {
    navigator.clipboard.writeText(text)
    snackbar.success('Copiado para área de transferência')
};

const showAssistents = () => {
    router.push("/assistentes")
};

</script>

<style lang='scss' scoped>
@use '@/ai_studio/styles/components/assistents-configuration.scss';

.tab-content {
    padding-bottom: 80px;
}

.integration-data-content p,
.integration-data-content b {
    font-family: Roboto;
    line-height: 24px;
    font-size: 16px;
    letter-spacing: 0.5px;
}

.integration-data-content p {
    color: rgb(var(--v-theme-neutral-10));
    font-weight: 400;
}

.integration-data-content b {
    color: #006A6A;
    font-weight: 700;
}

.buttons-container {
	padding: 16px 32px;
}

.navigation-buttons {
	position: fixed;
	bottom: 0;
	left: calc(var(--sidebar-width) + 4px);
	right: 0;
	background: white;
	z-index: 2;
	transition: left 0.2s ease;
}
</style>
